import React, { Component } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import {
  formatDate,
  formatDateTime,
  numberWithCurrency
} from '../../../utils/format';

class Single extends Component {
  render() {
    const {
      current,
      current: { customer, amount, company, products }
    } = this.props;

    return (
      <div className="invoice">
        <Row>
          <Col xs={6}>
            {customer ? (
              <p>
                {customer.name}
                <br />
                {customer.address}
                <br />
                {`${customer.zipcode} ${customer.city}`}
                <br />
              </p>
            ) : null}
          </Col>
          <Col xs={6} style={{ textAlign: 'right' }}>
            <p>
              {company.name}
              <br />
              {company.address}
              <br />
              {`${company.zip} ${company.city}`}
              <br />
              {`${this.i18n('VAT no.')}: ${company.tax}`}
              <br />
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={6} style={{ textAlign: 'left', marginTop: '1em' }}>
            <p>
              {this.i18n('Date')}
              :&nbsp;
              <span
                style={{
                  background: '#f6f6f6',
                  padding: '2px 1em',
                  marginLeft: '0',
                  display: 'inline-block',
                  whiteSpace: 'nowrap'
                }}
              >
                {formatDate(current.timestamp)}
              </span>
            </p>
          </Col>

          <Col xs={6} style={{ textAlign: 'right', marginTop: '1em' }}>
            <p>
              {this.i18n('Order no.')}: {current.orderno}
              <br />
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Table
              style={{
                borderBottom: '1px solid #eeeeee',
                borderTop: '1px solid #eeeeee',
                marginTop: '1em',
                marginBottom: '0.5em'
              }}
            >
              <thead>
                <tr>
                  <th>{this.i18n('Product')}</th>
                  <th>{this.i18n('Price')}</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{this.i18n(product.label)}</td>
                      <td>{numberWithCurrency(product.subtotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={6} smOffset={6}>
            <Table condensed className="invoice-total">
              <tbody>
                <tr>
                  <td>{this.i18n('Subtotal')}</td>
                  <td>
                    {numberWithCurrency(
                      products.reduce((sum, product) => sum + product.price, 0)
                    )}
                  </td>
                </tr>
                <tr>
                  <td>{this.i18n('VAT')}</td>
                  <td>
                    {numberWithCurrency(
                      products.reduce((sum, product) => sum + product.vat, 0)
                    )}
                  </td>
                </tr>
                <tr>
                  <th>{this.i18n('Total DKK')}</th>
                  <th>{numberWithCurrency(amount)}</th>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <p
          style={{
            fontSize: '0.8em',
            marginTop: '3em',
            paddingTop: '1.5em',
            borderTop: '1px solid #ddd',
            color: '#666'
          }}
        >
          {this.i18n('Timestamp')}: {formatDateTime(current.timestamp)}
          <br />
          {this.i18n('Transaction ID')}: {current.uuid}
          <br />
        </p>
      </div>
    );
  }
}

export default i18n(Single);
